
<template>
  
  <section class="login-2">
    <pageLoader v-if="ploader" :loadingText="'En cours de chargement'"/>
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="content-wrapper d-flex align-items-stretch auth auth-img-bg">
          <div class="row flex-grow">
            <div class="col-lg-6 d-flex align-items-center justify-content-center">
              <div class="auth-form-transparent text-left p-3">
                <div class="brand-logo">
                  <img src="../../../assets/images/logo-ailem.jpg" alt="logo">
                </div>

                <h4>Bienvenue!</h4>
                <h6 class="font-weight-light">Content de vous revoir!</h6>
                <!-- début form -->
                <form class="pt-3" @submit.prevent="handleSubmit">
                  <b-alert show variant="warning" v-if="error"><a href="javascript:void(0);" class="alert-link">Mot de passe ou identifiant incorrect. Veuillez réessayer.</a></b-alert>

                  <div class="form-group">
                    <label for="exampleInputEmail">Nom d'utilisateur</label>
                    <div class="input-group">
                      <div class="input-group-prepend bg-transparent">
                        <span class="input-group-text bg-transparent border-right-0">
                          <i class="mdi mdi-account-outline text-primary"></i>
                        </span>
                      </div>
                      <input type="text" class="form-control form-control-lg border-left-0" id="userName" v-model="userName" placeholder="Nom d'utilisateur" required>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="exampleInputPassword">Mot de passe</label>
                    <div class="input-group">
                      <div class="input-group-prepend bg-transparent">
                        <span class="input-group-text bg-transparent border-right-0">
                          <i class="mdi mdi-lock-outline text-primary"></i>
                        </span>
                      </div>
                      <input type="password" class="form-control form-control-lg border-left-0" id="password" v-model="password" placeholder="Mot de passe" required>
                    </div>
                  </div>
                  <!-- <div class="my-2 d-flex justify-content-between align-items-center">
                    <div class="form-check">
                      <label class="form-check-label text-muted">
                        <input type="checkbox" class="form-check-input"><i class="input-helper"></i>
                        Rester connecté
                      </label>
                    </div>
                    <router-link to="/lock-screen">
                    <a href="javascript:void(0);" class="auth-link text-info">Mot de passe oublié?</a>
                    </router-link>
                  </div> -->
                  <div class="my-3">
                      <button id="submit_login" class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn" >SE CONNECTER <span v-show="loadingBar" class="circle-loader ml-2"></span></button>
                  </div>
                  <!-- <div class="text-center mt-4 font-weight-light"> Vous n'avez pas de compte?
                    <router-link to="/inscription" class="text-primary">Créer</router-link>
                  </div> -->
                </form>
              </div>
            </div>
            <div class="col-lg-6 login-half-bg d-flex flex-row">
              <p class="text-white font-weight-medium text-center flex-grow align-self-end">Copyright &copy; 2019 All rights reserved.</p>
            </div>
          </div>
        </div>
        <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>

</template>

<script src="https://unpkg.com/vue-cookies@1.7.4/vue-cookies.js"></script>
<script>
import router from '../../../router/db'
import { mapState, mapGetters } from "vuex";
import pageLoader from '../../../components/pageLoader.vue'
import axios from 'axios'
import { refreshAfterInactivityMixin } from '../mixins/refresh_after_inactivity';
import lineC3Vue from '../../../components/charts/c3-chart/line-c3.vue';

export default {
  name: 'authentification',
  mixins:[refreshAfterInactivityMixin],
  components: {
      pageLoader
  },
  data () {
    return {
      userName:null,
      password: null,
      error:false,
      ploader:true,
      loadingBar:false
    }
  },
    computed: {
      ...mapState({
            main_api_url: state=> state.globalVariable.main_api_url
        }),
        // ...mapGetters(["getAuth"])
  },
  methods: {
    async handleSubmit(){
      // nettoyage du lcg avant la connexion
      localStorage.clear()
          const formData = {
              username:this.userName,
              password:this.password,
          }
          this.ploader =true
          axios.post(`${this.main_api_url}/login`,formData,{ withCredentials:true })
            .then(
                reser => {
                  localStorage.setItem('refresh_token', reser.data.refresh_token)
                  localStorage.setItem('roles', reser.data.Roles)
                  let refresh_token = localStorage.getItem('refresh_token')

                  this.$store.commit('setRefreshToken', refresh_token)
                  localStorage.setItem('roles', reser.data.Roles)
                  // this.$store.commit('setLoginInfo', formData)
                  this.$router.push({
                    name:"applications"
                  })
              }
            )
            .catch(err =>{
              if(err.response.status == 401) {
                alert (`Votre nom d'utilisateur ou mot de passe est incorrect`)
                this.ploader=false
                return
              }
              if(err.response.status == 500) {
                alert(`Une erreur a été rencontré sur le serveur, merci de notifier ce problème aux développeurs`)
                this.ploader = false
                return
              }
            })
      },
      // myInfos(){
      //   axios.get(`myinfos`)
      //   .then(resMyInfos => {
      //     console.log(resMyInfos);
      //       router.replace('/dashboard')
      //   })
      //   .catch(( ) => {
      //   })
      // }
  },
  beforeCreate(){
    delete axios.defaults.headers.common['X-AUTH-TOKEN'];
  },
  created(){
    // if(this.getAuth)
    // {
    //   router.replace('/dashboard')
    // }
  },
  mounted(){
    // this.$store.dispatch('AutoLogin')
    // if(localStorage.getItem('backend')){
    //   this.myInfos()
    // }
    this.ploader = false
  }
  
}
</script>
<style scoped>
a:hover {
  color:inherit;
  text-decoration: none;
}
.auth-form-btn:active, .auth-form-btn:focus {
  background: linear-gradient(to right, #874fa2, #7540c3) !important
}
</style>